<div class="task-checkbox">
  <div
    *ngIf="
      task?.status !== TaskStatus.COMPLETED &&
      task?.shouldShowCompleteSubtasksPopover &&
      !disableSubtasksPopover
    "
    class="task-checkbox__popover-trigger"
    confirmationPopover
    #cp="confirmationPopover"
    [isDisabled]="disabled"
    [placement]="placement"
    [appendToBody]="true"
    [closeOnScroll]="true"
    [confirmButtonType]="'primary'"
    [cancelText]="'ProjectTasks.Task.cancelCompletedSubtasks' | translate"
    [confirmText]="'ProjectTasks.Task.confirmCompletedSubtasks' | translate"
    [popoverMessage]="'ProjectTasks.Task.doYouWantToCompletedSubtasks' | translate"
    [popoverTitle]="'ProjectTasks.Task.doYouWantToCompletedSubtasksTitle' | translate"
    (confirm)="setCompletedForSubtasks()"
    (cancel)="completeOnlyCurrentTask()"
    (isOpenChange)="onPopoverOpenChange($event)"
    (click)="onCheckboxWithSubtasksClick($event)"
  >
    <mat-checkbox
      class="task-checkbox__input task-checkbox__input--popover"
      [checked]="checked"
      [disabled]="disabled"
    />
  </div>

  <mat-checkbox
    *ngIf="
      (task?.status !== TaskStatus.COMPLETED &&
        (!task?.shouldShowCompleteSubtasksPopover || disableSubtasksPopover)) ||
      task?.status === TaskStatus.COMPLETED
    "
    class="task-checkbox__input"
    [disabled]="disabled"
    [checked]="checked"
    (change)="onDefaultCheckboxChange($event)"
  />
</div>
